const VALID_ALIGNMENTS = new Set(["left", "center", "right", "inline"]);

const normalizeAlignment = (value) => {
  const normalized = String(value ?? "").trim().toLowerCase();
  return VALID_ALIGNMENTS.has(normalized) ? normalized : null;
};

// Keep the same precedence as the Word export renderer.
export function getQuestionImageAlignment(asset, overrides = {}, fallback = "right") {
  const override = asset?.id == null ? null : normalizeAlignment(overrides?.[String(asset.id)]);
  if (override) return override;
  for (const source of [asset, asset?.metadata]) {
    for (const field of ["alignment", "align", "image_alignment"]) {
      const alignment = normalizeAlignment(source?.[field]);
      if (alignment) return alignment;
    }
    if ([source?.layout, source?.text_layout].some((value) => String(value ?? "").trim().toLowerCase() === "inline")) {
      return "inline";
    }
  }
  return normalizeAlignment(fallback) || "right";
}
